import React, { useState } from 'react';
import { InputGroup, Form, Image } from 'react-bootstrap';

import { Http } from '../../../../support';
import Loading from '../../../../facturotopia/loading/Loading';
import ResponseError from '../../../../shared/responses/ResponseError';

const EmpresaCustomization = (props) => {
  const [state, setState] = useState({});

  const handleOnFileChange = (event) => {
    const { name } = event.target;
    const { empresa, onLogoUpdated } = props;

    const files = Array.from(event.target.files);

    setState({
      uploading: true,
      uploadError: undefined,
    });

    const formData = new FormData();

    files.forEach((file, i) => {
      formData.append(name, file);
    });

    Http.post(`/api/empresas/${empresa.id}/logo`, formData)
      .then(
        (response) => {
          window.ToastManager.show({
            variant: 'success',
            title: 'Personalización',
            message: response.message || 'Logo actualizado',
          });

          if (onLogoUpdated) {
            onLogoUpdated(response.data);
          }
        },
        (error) => {
          setState({
            uploadError: error.data || error,
          });
        }
      )
      .catch((error) => {
        setState({
          uploadError: error.data || error,
        });
      })
      .finally(() => {
        setState({
          uploading: false,
        });
      });
  };

  const renderUploadError = () => {
    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={state.uploadError}
          onAction={handleOnCloseError}
        />
      </div>
    );
  };

  const handleOnCloseError = () => {
    setState({
      uploadError: undefined,
    });
  };

  const { logo } = props.empresa;
  const { uploading, uploadError } = state;

  return (
    <>
      {!!uploadError && renderUploadError()}

      <Form.Group>
        <Form.Label>
          <strong>Tu logo</strong>
        </Form.Label>
        <InputGroup className="mb-3">
          <input
            type="file"
            name="logo"
            accept="image/jpg, image/jpeg, image/png"
            onChange={handleOnFileChange}
            onClick={(event) => {
              event.target.value = null;
            }}
          />
        </InputGroup>

        {uploading && <Loading />}

        {!!logo && (
          <Image
            src={logo}
            thumbnail
          />
        )}
      </Form.Group>
    </>
  );
};

export default EmpresaCustomization;
